import React from "react";
import { ReactComponent as CircleTickIcon } from "../assets/circle_tick.svg";
import CustomButton from "./CustomButton";
import { Modal } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CloseIcon } from "../assets/iconamoon_close.svg";

const SurewanttoExit = ({
  opened,
  close,
  handleSaveClick,
  messageText = "",
  messagePara = "",
  active,
  btnCancelText = "discard",
  btnSavetext = "Save",
  isNew = false,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        opened={opened}
        onClose={close}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
        closeOnClickOutside={false}
      >
        <div className="exit-modal-wrapper">
          <CloseIcon
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              cursor: "pointer",
            }}
            onClick={() => close(false)}
          />
          <CircleTickIcon />
          <h1
            className="header"
            style={{ color: "#314064", textAlign: "center" }}
          >
            {messageText}
          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            {messagePara}
          </p>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <CustomButton
              style={{ width: "40%" }}
              btnText={btnCancelText}
              type="secondary"
              flex={1}
              onClick={() => {
                close(false);
                // Clear all localStorage keys used by child components
                if (!isNew) {
                  localStorage.removeItem("travelerInformationData");
                  localStorage.removeItem("claimType");
                  localStorage.removeItem("OriginallyBookedFlightsData");
                  localStorage.removeItem("actualFlightDetailsData");
                  localStorage.removeItem("completedStep");

                  // Navigate to the start page
                  navigate("/start-your-claim");
                }
              }}
            />
            {/* <CustomButton
              style={{ width: "40%" }}
              btnText={"Save"}
              flex={1}
              onClick={() => {
                handleSaveClick();
                close(false);
              }}
            /> */}
            {(active >= 1 && active <= 8) && (
              <CustomButton
                style={{ width: "40%" }}
                btnText={btnSavetext}
                onClick={handleSaveClick}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SurewanttoExit;
